'use strict'

export default {
  //UndefinedException: class extends Error {
  //  constructor (message, name) {
  //    super(message + '...[name : ' + name + ']')
  //    Error.captureStackTrace(this, this.constructor)
  //    this.name = this.constructor.name
  //  }
  //},
  ApiResonseError: class extends Error {
    constructor (message, url, httpStatus, result) {
      super(
        message +
          '...[url + ' +
          url +
          ', httpStatus : ' +
          httpStatus +
          ', result : ' +
          result +
          ']'
      )
      Error.captureStackTrace(this, this.constructor)
      this.name = this.constructor.name
      this.result = result
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/general/exception.js